<template>
  <div class="s-solutions-slick">
    <div class="page-container">
      <div v-if="percentage" class="s-solutions-slick__progress-bar">
        <ProgressBar :percentage="percentage" />
      </div>

      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-solutions-slick__slick"
        :options="slickOptions"
        @init="onInit"
        @beforechange="onBeforeChange">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-solutions-slick__slide item">
          <Solution :item="item" />
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import ProgressBar from './../components/common/ProgressBar.vue'
import Solution from '../components/Solution.vue'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: { ProgressBar, Solution, SlickCarousel },

  data() {
    return {
      percentage: 0,
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 1, variableWidth: false },
          },
        ],
      },
    }
  },
  mounted() {
    const { records } = lib.getData('solutionsData')
    this.records = records

    if (this.configuration.variableWidth) {
      this.slickOptions.slidesToShow = 1
      this.slickOptions.variableWidth = true
      this.slickKey = uuidv4()
    }
  },
  methods: {
    onInit(event, slick) {
      this.percentage = lib.getSlickProgressBarPercentage(slick)
    },
    onBeforeChange(event, slick) {
      setTimeout(() => {
        this.percentage = lib.getSlickProgressBarPercentage(slick)
      }, 100)
    },
  },
}
</script>
